import {
  MANUAL_OPP_TYPES,
  OCDS_OPP_FIELDS,
  SIMPLE_OPP_FIELDS,
  US_GOV_CON_OPP_FIELDS,
} from "constants/opportunities";

const OPP_TYPE_URLS = {
  [MANUAL_OPP_TYPES.SIMPLE]: "/nextgen/opportunity/manual",
  [MANUAL_OPP_TYPES.OCDS]: "/nextgen/opportunity/ocds",
};

export const getOpportunityUrl = (oppType) =>
  OPP_TYPE_URLS[oppType] ?? "/nextgen/opportunity/sam-gov";

export const getFormDataForNewOpportunity = (data, oppType) => {
  const fields =
    oppType === MANUAL_OPP_TYPES.SIMPLE
      ? SIMPLE_OPP_FIELDS
      : oppType === MANUAL_OPP_TYPES.OCDS
        ? OCDS_OPP_FIELDS
        : US_GOV_CON_OPP_FIELDS;

  const payload = {};

  fields.forEach((field) => {
    const value = data[field];
    if (value !== undefined && value !== null && value !== "") {
      payload[field] = Array.isArray(value) ? value.map((v) => String(v).trim()).join(", ") : value;
    }
  });

  if (data.id) {
    payload.id = data.id;
  }
  return payload;
};
